/**
 * 时间日期相关操作
 */


/**
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成 2018/09/23 11:54:16
 * @param datetime 国际化日期格式
 */
export function format (datetime) {
  return formatWithSeperator(datetime, "/", ":");
}

/**
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成类似 2018/09/23 11:54:16
 * 可以指定日期和时间分隔符
 * @param datetime 国际化日期格式
 */
export function formatWithSeperator (datetime, dateSeprator, timeSeprator) {
  if (datetime != null) {
    const dateMat = new Date(datetime);
    const year = dateMat.getFullYear();
    const month = dateMat.getMonth() + 1;
    const day = dateMat.getDate();
    const hh = dateMat.getHours();
    const mm = dateMat.getMinutes();
    const ss = dateMat.getSeconds();
    const timeFormat = year + dateSeprator + month + dateSeprator + day + " " + hh + timeSeprator + mm + timeSeprator + ss;
    return timeFormat;
  }
}

export function dateFormat (row, column, cellValue, index) {
  return format(row[column.property]);
}

/**
 * 星期格式化
 * 将 1 2 3 格式化为星期一 星期二 星期三
 * @param datetime 国际化日期格式
 */
export function weekFormat (row, column, cellValue, index) {
  let weekLabel = ""
  let value = parseInt(row[column.property]);
  switch (value) {
    case 1:
      weekLabel = "星期一";
      break;
    case 2:
      weekLabel = "星期二";
      break;
    case 3:
      weekLabel = "星期三";
      break;
    case 4:
      weekLabel = "星期四";
      break;
    case 5:
      weekLabel = "星期五";
      break;
    case 6:
      weekLabel = "星期六";
      break;
    case 7:
      weekLabel = "星期日";
      break;
    default:
      weekLabel = "未知";
  }
  return weekLabel;
}

/**
 * 星期格式化
 * 将 1 2 3 格式化为上午 下午 晚间
 * @param datetime 国际化日期格式
 */
export function ampmFormat (row, column, cellValue, index) {
  let timeState = ""
  let value = parseInt(row[column.property]);
  switch (value) {
    case 1:
      timeState = "上午";
      break;
    case 2:
      timeState = "下午";
      break;
    case 3:
      timeState = "夜门诊";
      break
    case 4:
      timeState = "全天";
      break;
    default:
      timeState = "未知";
  }
  return timeState;
}





// WEBPACK FOOTER //
// ./src/utils/datetime.js